import React, {useLayoutEffect} from "react";

import Breadcrumb from "./_components/Breadcrumb";

export default function Breadcrumbs({
  currentStep,
  setCurrentStep,
  items
}) {

  useLayoutEffect(() => {

    const activeBreadcrumb = document.querySelector('.gc__breadcrumb_active');

    if (typeof(window.GCP) == 'undefined') {
      window.GCP = {};
    }

    if (typeof(window.GCP.state) == 'undefined') {
      window.GCP.state = {};
    }

    if (activeBreadcrumb && currentStep !== window.GCP.state.lastCurrentStep && currentStep !== "greeting_card" && window.innerWidth < 900) {
      window.GCP.state.lastCurrentStep = currentStep;
      window.scrollTo(0, activeBreadcrumb.offsetTop);
    }


  });

  const breadcrumbs = items.map((item, index) => {
    return ((item !== null) ?
      <Breadcrumb
        key={`${item.value}_${index}`}
        value={item.value}
        label={item.label}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        valid={item.valid}
        disabled={item.disabled}
      />
    : null)
  })
  return (
    <div className="gc__form_header gc__section">
      <ul className="gc__breadcrumbs">
        {breadcrumbs}
      </ul>
    </div>
  )
}
